import { useMemo } from 'react';
import {
  useOneCmsLocaleCommonContent,
  useOneCmsLocaleProductContent,
} from './oneCmsIntlFetchyeHooks';

export const useCommonContent = () => {
  const { data } = useOneCmsLocaleCommonContent();
  return data?.body ?? {};
};

export const useProductContent = () => {
  const { data } = useOneCmsLocaleProductContent();
  return data?.body ?? {};
};

export const useIsDefaultLoungebuddy = () => {
  const { config } = useCommonContent();
  return config?.defaultLoungebuddy ?? true;
};
// Overview

export const useOneCmsLocaleOverviewObj = () => {
  const content = useProductContent();
  return content?.pageSectionCopy?.overview ?? null;
};

export const useOneCmsLocaleOverviewHeader = () => {
  const overview = useOneCmsLocaleOverviewObj();
  return overview?.header ?? null;
};

export const useOneCmsLocaleOverviewBody = () => {
  const overview = useOneCmsLocaleOverviewObj();
  return overview?.body ?? null;
};

export const useOneCmsLocaleOverviewDisclaimer = () => {
  const overview = useOneCmsLocaleOverviewObj();
  return overview?.disclaimer ?? null;
};
// Page Section -> Results

export const useOneCmsLocaleResultsObj = () => {
  const content = useCommonContent();
  return content?.results ?? null;
};

export const useOneCmsLocaleResultsOverrideWithPlaceholder = () => {
  const content = useCommonContent();
  return content?.results?.override_with_placeholder ?? null;
};

export const useOneCmsLocaleResultsDetaisBtnLabel = () => {
  const content = useCommonContent();
  return content?.results?.detailsButton ?? null;
};

export const useOneCmsLocaleDateFormattingObj = () => {
  const { config } = useCommonContent();
  return config?.dateFormatting ?? null;
};

export const useOneCmsLocaleTimeFormat = () => {
  const { config } = useCommonContent();
  return config?.dateFormatting?.timeFormat ?? null;
};
// Partners

export const useOneCmsLocalePartners = () => {
  const { data } = useOneCmsLocaleProductContent();
  return useMemo(() => {
    const partners = data?.body?.partners ?? null;
    return (
      partners?.sort((partnerA, partnerB) => {
        return partnerA.order < partnerB.order ? -1 : 1;
      }) ?? []
    );
  }, [data]);
};

export const useOneCmsLocaleDetailsAmenities = () => {
  const { amenities } = useCommonContent();
  return amenities?.items ?? [];
};
// Search

export const useOneCmsLocaleSearchObj = () => {
  const content = useCommonContent();
  return content?.search ?? null;
};

export const useOneCmsLocaleMinimumSearchLength = () => {
  const search = useOneCmsLocaleSearchObj();
  const localeMinSearchLength = search?.searchQueryLength ?? null;
  if (!localeMinSearchLength || Number.isNaN(localeMinSearchLength)) {
    return 3;
  }
  return localeMinSearchLength;
};

export const useOneCmsWaitlistContent = () => {
  const content = useCommonContent();
  return content?.waitlist ?? null;
};

export const useCenturionNetworkCarouselImages = () => {
  const content = useCommonContent();
  const centurionNetwork = content?.centurionNetwork;
  return centurionNetwork?.carouselImages ?? [];
};
